import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
const UnitForm = (props) => {
  const frmRef = useRef({});
  const [inputunit, setinputunit] = useState();
  const [baseUnit, setbaseUnit] = useState("");

  const [unitdata, setUnitData] = useState([]);

  const [unitTypedata, setUnitTypedata] = useState([]);
  const [unitTypeId, setUnitTypeId] = useState("");

  const { sendRequest: getUnitTypeData } = useHttp();
  useEffect(() => {
    getUnitTypeData(
      {
        url: "/api/unit-categories/",
      },
      (res) => {
        if (res) {
          setUnitTypedata(res);
        }
      }
    );
  }, [getUnitTypeData]);
  const { sendRequest: getUnitData } = useHttp();

  const fillUnitDetail = () => {
    getUnitData(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setUnitData(res);
          //console.log(unitdata);
        }
      }
    );
  };

  useEffect(() => {
    fillUnitDetail();
  }, [getUnitData]);

  const { sendRequest: postUnit } = useHttp();

  const unitsubmitHandler = (e) => {
    e.preventDefault();
    var unitName = frmRef.current.unitName.value.trim();
    var unitAbbreviation = frmRef.current.unitAbbreviation.value.trim();
    var conversionRation = frmRef.current.conversionRation.value.trim();
    var unitTypeId1 = unitTypeId;

    const data = {
      unitTypeId: unitTypeId1,
      unitName: unitName,
      unitAbbreviation: unitAbbreviation,
      conversionRation: conversionRation,
      isBaseUnit: false,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
      serviceId: props.sId,
    };

    console.log(data);
    postUnit(
      {
        url: "/api/units/",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Unit detail added`);
        props.addForm(false);
      }
    );
  };

  const unitTypeOnChanged = (e) => {
    //console.log(e.target.value)
    var unitTypeId1 = e.target.value;
    setUnitTypeId(unitTypeId1);
    var baseUnitList = unitdata.filter(
      (item) => item.isBaseUnit == true && item.unitTypeId == unitTypeId1
    );
    if (baseUnitList && baseUnitList.length > 0) {
      setbaseUnit(baseUnitList[0].unitAbbreviation);
      frmRef.current.baseUnit.text = baseUnitList[0].unitAbbreviation;
    }
  };
  function handleKeyPress(e) {
    setinputunit(e.target.value);
  }

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form onSubmit={unitsubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Unit Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit Type</label>

                        <select
                          id="unittype"
                          className="form-control"
                          onChange={unitTypeOnChanged}
                          required
                        >
                          <option value="">Select Unit Type</option>
                          {unitTypedata &&
                            unitTypedata.map((x) => (
                              <option
                                key={x.unitCategoryId}
                                unitCategory-id={x.unitCategoryId}
                                value={x.unitCategoryId}
                              >
                                {x.unitTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit Name </label>
                        <input
                          type={"text"}
                          id={"unit"}
                          required
                          ref={(el) => (frmRef.current["unitName"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Abbreviation</label>
                        <input
                          type={"text"}
                          id={"unit"}
                          required
                          ref={(el) =>
                            (frmRef.current["unitAbbreviation"] = el)
                          }
                          onChange={(e) => handleKeyPress(e)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Base Unit </label> <br />
                        <label>1</label> &nbsp;
                        <label htmlFor={"unit"}>{inputunit}</label>
                      </div>
                    </div>

                    <div className="col-md-1">
                      <div className="form-group">
                        <br />
                        <label>=</label> &nbsp;
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit Convserion </label>
                        <div>
                          {" "}
                          <input
                            type={"number"}
                            pattern="[0-9]+([\.,][0-9]+)?"
                            step="0.000001"
                            id={"unit"}
                            style={{ width: "70%" }}
                            required
                            ref={(el) =>
                              (frmRef.current["conversionRation"] = el)
                            }
                            className="form-control"
                          />
                          <label
                            htmlFor={"unit"}
                            ref={(el) => (frmRef.current["baseUnit"] = el)}
                          >
                            {baseUnit}
                          </label>{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default UnitForm;
